/** Admin Activities API (CRUD + workflow). */
import apiClient from '@/services/api/client';

export const listActivities = async () => (await apiClient.get('/v1/activities')).data;
export const createActivity = async (p) => (await apiClient.post('/v1/activities', p)).data;
export const updateActivity = async (id, p) => (await apiClient.put(`/v1/activities/${id}`, p)).data;
export const approveActivity = async (id) => (await apiClient.post(`/v1/activities/${id}/approve`)).data;
export const publishActivity = async (id) => (await apiClient.post(`/v1/activities/${id}/publish`)).data;
export const archiveActivity = async (id) => (await apiClient.post(`/v1/activities/${id}/archive`)).data;
export const deleteActivity = async (id) => apiClient.delete(`/v1/activities/${id}`);
